exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Website: https://www.4myth.com\n * Email: mythpe@gmail.com\n * Mobile: +966590470092\n * Copyright © 2018-2024  All rights reserved.\n * MyTh Ahmed\n */.theme--light.v-small-dialog__menu-content,.theme--light.v-small-dialog__actions{background:#fff}.theme--dark.v-small-dialog__menu-content,.theme--dark.v-small-dialog__actions{background:#1e1e1e}.v-small-dialog{display:block}.v-small-dialog__activator{cursor:pointer}.v-small-dialog__activator__content{display:inline-block}.v-small-dialog__content{padding:0 16px}.v-small-dialog__actions{padding:8px;text-align:right;white-space:pre}", ""]);

// exports
